import { PageLoader, type Jobs } from '@seek/libs-shared';
import { useRouteLoaderData } from 'react-router';
import { useService } from '../../../';

import { CompanyProfilesPage } from '../../../paths';
import { JobsPage } from '../../pages/jobs/JobsPage';
import type { JobsModel } from './jobsModel';

export function JobsPageContainer({
  trackJobsPaginationClicked,
}: {
  trackJobsPaginationClicked: ({
    searchTotalCount,
    pageNumber,
  }: {
    pageNumber: number;
    searchTotalCount?: number | undefined;
  }) => void;
}) {
  const model = useRouteLoaderData(CompanyProfilesPage.Jobs) as JobsModel;

  const { companyProfileService } = useService();

  const getPaginatedJobs = async (
    organisationId: string,
    page?: number,
  ): Promise<Jobs> => {
    const res = await companyProfileService.getJobs(organisationId, page);
    return res;
  };

  return model ? (
    <JobsPage
      model={model}
      getPaginatedJobs={getPaginatedJobs}
      trackJobsPaginationClicked={trackJobsPaginationClicked}
    />
  ) : (
    <PageLoader />
  );
}
